<div class="card shadow-sm w-100 h-100 card-resource cursor-pointer" [class.h-100]="swiperEnabled">
    <img loading="lazy" class="card-img-top" [src]="image" (click)="gotoPost(slug)" />
    <div class="card-body pb-0" (click)="gotoPost(slug)">
        <h5 class="card-title font-size-24 mb-2">
            <a [routerLink]="['/notice-board/post/', slug]">{{ title }}</a>
        </h5>
        <p class="card-description font-size-15">{{ summary }}</p>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <p class="card-date font-size-14">{{ date | date: 'dd/MM/yyyy' }}</p>
            </div>
            <div class="col-auto text-right">
                <ng-container *ngIf="tagged">
                    <div class="blog-tag font-size-12 font-weight-bold text-uppercase"
                         *ngFor="let tag of tagged" (click)="fetchPostsByTag(tag.tag_name)">
                        <a [routerLink]="['/notice-board/']" [queryParams]="{tag: tag?.tag_name}">
                            {{ tag?.tag_name }}
                        </a>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>